import type {Extension} from '@codemirror/state'
import {EditorView} from '@codemirror/view'

/**
 * Navigate to links when the `Mod` key is held down while clicking;
 * plain clicking simply moves the caret as with other editable text.
 */
function handleClick(mouseEvent: MouseEvent) {
  if (mouseEvent.target instanceof HTMLAnchorElement && (mouseEvent.metaKey || mouseEvent.ctrlKey)) {
    window.open(mouseEvent.target.href, '_blank', 'noopener,noreferrer')
    return true // event handled
  }
}

/** Extension that handles clicks on the editor by navigating to links when they're the click target. */
export function visitLinkExtension(): Extension {
  return [
    EditorView.domEventHandlers({
      click: handleClick,
    }),
  ]
}
